module.exports = __webpack_public_path__ + "static/img/logo13.fa4e260.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo13.jpg
// module id = 5Bpp
// module chunks = 1